import Joi from "joi";
import errorsResolver from "../../../../validation/schemeUtils";

export const debtReportValidationSchema = Joi.object({
  departments: Joi.array()
    .custom((value, helpers) => {
      const { reportType } = helpers.state.ancestors[0];
      
      if (!reportType && value.length === 0) {
        return helpers.error("any.invalid");
      }
      return value;
    })
    .error(
      errorsResolver({
        invalid:
          'Выберите подразделение или отметьте "Все подразделения"',
      })
    ),
  reportType: Joi.boolean().required(),
  reportDateType: Joi.string().allow(null),
  date: Joi.date()
  .iso()
  .error(errorsResolver({
      dateFormat: `Некорректная дата`,
  }))
});
